import { useMutation } from '@tanstack/react-query';
import {
  transferSection,
  TransferSectionInput,
} from 'shared/services/backend-api';

export const useTransferSectionMutation = () =>
  useMutation({
    mutationFn: async (input: TransferSectionInput) => transferSection(input),
  });
